/** Pages created offline (client UUIDv7, spec §16.1) awaiting registration on reconnect (§16.2 step 3). */
import { registerPage } from "../api/hooks";
import { getMeta, setMeta } from "../sync/persistence";

interface Pending {
  ws: string;
  id: string;
  title: string;
}
const KEY = "pendingPages";

export async function addPendingPage(p: Pending): Promise<void> {
  const cur = (await getMeta<Pending[]>(KEY)) ?? [];
  if (!cur.some((x) => x.id === p.id)) await setMeta(KEY, [...cur, p]);
}

export async function registerPendingPages(): Promise<number> {
  const cur = (await getMeta<Pending[]>(KEY)) ?? [];
  const remaining: Pending[] = [];
  let done = 0;
  for (const p of cur) {
    try {
      await registerPage(p.ws, p.id, p.title);
      done += 1;
    } catch (e) {
      const status = (e as { status?: number }).status;
      if (status === 409 || status === 403) continue; // not ours / not allowed: drop
      remaining.push(p);
    }
  }
  await setMeta(KEY, remaining);
  return done;
}
